import { Clipboard } from '@angular/cdk/clipboard';
import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ViewComponent } from 'src/app/pages/abstract/view.component';
import { ApiKey, ApiKeyService } from 'src/app/services/apikey-service';
import { ToastService } from 'src/app/services/toast.service';


@Component({
    selector: 'apikey-display-dialog',
    templateUrl: 'apikey-display-dialog.html',
    styleUrls: ['apikey-display-dialog.scss'],
})
export class ApiKeyDisplayDialog extends ViewComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public params: { [key: string]: any },
        protected override injector: Injector,
        public dialogRef: MatDialogRef<ApiKeyDisplayDialog>,
        private router: Router,
        private apiKeyService: ApiKeyService,
        private clipboard: Clipboard,
        private toastService: ToastService,
        private translate: TranslateService,
        public dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: {
            apiKey: ApiKey
        },
    ) {
        super(injector);
    }

    akiKey: string;

    apikeyEditLink: string;

    ngOnInit() {
        if (this.data.apiKey) {
            this.akiKey = this.data.apiKey.apiKey;
            this.apikeyEditLink = `/apikeys/${this.data.apiKey.apiKey}`;
        } else {
            this.akiKey = "dummy";
            this.apikeyEditLink = `/apikeys/xxxxx`;
        }
    }

    copyToClipboard(): void {
        this.clipboard.copy(this.akiKey);
        this.toastService.info(this.translate.instant('MESSAGES.COPY_SUCCESS'), '');
    }


}
